import { Button, Divider, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import Sticky from 'react-sticky-el';

import Editor from '../../../../components/Shared/forms/EditorPrivacy';
import { useEffect } from 'react';
import { checkValidForm } from './Step1';
import BtnSave from './BtnSave';

const Step5 = (props) => {
    const { t } = useTranslation();

    const onNextStep = () => {
        props.nextStep();
        props?.form
            .validateFields()
            .then(() => {
                props.setStep5(true);
            })
            .catch(() => props.setStep5(false));
    };

    const onPreviousStep = () => {
        props.previousStep();
    };

    useEffect(() => {
        if (props?.previewData?.privacyPolicy) {
            onValuesChange(null, props.previewData?.privacyPolicy);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props?.previewData]);

    const onValuesChange = (change, allValues) => {
        const fields = [
            'policyWebsiteTh',
            'processPolicyTh',
            'undisclosedReasonTh',
        ];
        const check = checkValidForm(fields, allValues);
        props.setStep5(check);
    };

    return (
        <div className="px-4 block_">
            <div className="text-purple-PHX font-semibold text-2xl">
                {t('policy.des5')}
            </div>
            <div className="text-gray-500 text-tiny">{t('policy.desEtc')}</div>
            <Divider />
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                onValuesChange={onValuesChange}
                name="privacyPolicy"
                layout="vertical"
                form={props?.form}
            >
                <Form.Item
                    className="mt-4"
                    name={'policyWebsiteTh'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.policyWebsiteTh')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.retentionPeriodThPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name={'policyWebsiteEn'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.policyWebsiteEn')}
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.retentionPeriodEnPl')}
                    />
                </Form.Item>
                <Divider />
                <Form.Item
                    className="mt-4"
                    name={'undisclosedReasonTh'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.undisclosedReasonTh')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.transferPersonalDataThPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name={'undisclosedReasonEn'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.undisclosedReasonEn')}
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.transferPersonalDataEnPl')}
                    />
                </Form.Item>
                <Divider />
                <Form.Item
                    className="mt-4"
                    name={'processPolicyTh'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.processPolicyTh')}
                        </span>
                    }
                    rules={[
                        {
                            required: true,
                            message: t('errorText.requiredField'),
                        },
                    ]}
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.transferPersonalDataThPl')}
                    />
                </Form.Item>
                <Form.Item
                    className="mt-4"
                    name={'processPolicyEn'}
                    label={
                        <span className="text-[21px] font-bold">
                            {t('policy.processPolicyEn')}
                        </span>
                    }
                >
                    <Editor
                        size="large"
                        rows={4}
                        placeholder={t('policy.transferPersonalDataEnPl')}
                    />
                </Form.Item>
                <Sticky
                    mode="bottom"
                    boundaryElement=".block_"
                    stickyClassName="bg-white p-4 shadow h-16 rounded-lg z-50"
                >
                    <div className="flex items-center">
                        <Button
                            type="default"
                            size="large"
                            onClick={onPreviousStep}
                        >
                            <ArrowLeftOutlined /> {t('policy.PreviousStep')}
                        </Button>
                        <Button
                            type="primary"
                            size="large"
                            className="ml-4"
                            onClick={onNextStep}
                        >
                            {t('policy.NextStep')} <ArrowRightOutlined />
                        </Button>
                        <BtnSave saveDraft={props.saveDraft} />
                    </div>
                </Sticky>
            </Form>
        </div>
    );
};

export default Step5;
